<div class="content-inner">
    <div class="form-body">
      <section class="workflow-input-group">
        <div class="workflow-input totals">
          <input type="text" [value]="currentCensus" attr.aria-label="Total Census" disabled>
          <span class="display-label">Current Census <a href="#" class="button compact" (click)="back()"><span class="icon-pencil"></span> Edit</a></span>
        </div>

        <div class="workflow-input" [formGroup]="midnightForm" *ngIf="isMidnightBlock()">
          <input type="number" min="0" attr.aria-label="Midnight Census" formControlName="midnightControl">
          <span class="display-label">Midnight Census</span>
          <span *ngIf="!checkMidnightMaxCensus()" class="warning inline"><span class="icon-warning2"></span> 
            Must be Between {{shiftRecord.costCenter.inpatientConfiguration.minCensus}} and {{shiftRecord.costCenter.inpatientConfiguration.maxCensus}} </span>        
        </div>
      </section>


      <!-- Patient Ratios! -->
      <section *ngIf="isRatioBased()" [formGroup]="ratioForm" class="workflow-input-group">
        <div class="workflow-section-heading">Staff:Patient Ratios</div>
        <p>
          Enter the number of patients in each category for a total of <strong>{{ currentCensus }}</strong>
        </p>
        <div class="workflow-input patientRatio" *ngFor="let patientRatio of shiftRecord.costCenter.inpatientConfiguration.patientRatios">
          <input type="number" min="0"  pattern="[0-9]\d*$" [attr.aria-label]="patientRatio.label" [formControlName]="getRatioControlName(patientRatio.id)">
          <span class="display-label">{{ patientRatio.label }}</span>
        </div>
        <div class="workflow-input totals">
          <input type="text" disabled attr.aria-label="Total" [value]="ratioTotal">
          <span class="display-label">Total <span *ngIf="!isRatioValid()" class="warning inline"><span class="icon-warning2"></span> Should equal {{ currentCensus }}</span></span>
        </div>
      </section>

      <!-- Patient Churn! -->
      <section [formGroup]="censusForm" class="workflow-input-group">
        <div class="workflow-section-heading">Projected Census Churn</div>
        <div class="workflow-input">
          <input type="number" min="0" attr.aria-label="Actual Admits" formControlName="admits">
          <span class="display-label">Admits</span>
        </div>
            
        <ng-template [ngIf]="shiftRecord.costCenter.inpatientConfiguration.transfers">
          <div class="workflow-input">
            <input type="number" min="0" attr.aria-label="Actual Transfers In (+)" formControlName="transfersIn">
            <span class="display-label">Transfers In (+)</span>
          </div>  

          <div class="workflow-input">
            <input type="number" min="0" attr.aria-label="Actual Transfers Out (-)" formControlName="transfersOut">
            <span class="display-label">Transfers Out (-)</span>
          </div>
        </ng-template>

        <div class="workflow-input">
          <input type="number" min="0" attr.aria-label="Actual Discharges" formControlName="discharges">
          <span class="display-label">Discharges</span>
        </div>
        
        <div class="workflow-input totals">
          <input type="text" disabled attr.aria-label="Updated Census" [value]="projectedCensus">
          <span class="display-label">Projected Census 
          <span *ngIf="!isCensusFormValid()" class="warning inline"><span class="icon-warning2"></span> Please enter positive patient counts in each field.</span>      
          <span *ngIf="isCensusFormValid() && !isChurnValid()" class="warning inline"><span class="icon-warning2"></span> Must be between {{shiftRecord.costCenter.inpatientConfiguration.minCensus}} and {{shiftRecord.costCenter.inpatientConfiguration.maxCensus}}</span></span>
        </div>
      </section>

      <!-- Staffing! -->
      <section [formGroup]="staffForm">
        <div class="workflow-section-heading">Enter Staffing Levels
          <a *ngIf="this.shiftRecord.costCenter.variableJobTitles.length > 0" 
            class="workflow-section-link-small" (click)="openCurrentStaffingGrid()">
            <span class="icon-eye"></span> Review Staffing Grid
          </a>
        </div>
        <ng-container *ngIf="jobTitlesWithVariance && jobTitlesWithVariance.length > 0">
          <div class="warning notification" *ngFor="let varianceWarning of getVarianceWarnings()">
            <span class="icon-notification"></span> {{ varianceWarning }}
          </div>
        </ng-container>
        <div class="warning notification" *ngIf="hasRatioBasedRecommendation">{{ ratioStaffTarget }} Staff Recommended Based on Staff:Patient Ratios for: {{ ratioStaffLabels }}</div>
        <section *ngIf="shiftRecord.costCenter.variableJobTitles.length" class="workflow-input-group">
          <div class="workflow-section-subheading">Variable Staff 
              <span *ngIf="hasTimeAndAttendanceImports()" [ngClass]="hasImportedData() ? 'has-imported-data' : 'no-imported-data'" class="icon-download3" (click)="openImportedValuesModal()">&nbsp;</span>
              <button *ngIf="hasImportedData()" class="compact" (click)="toggleVariableJobEditing()"><span class="icon-pencil"></span> Edit</button>
          </div>
          <div class="workflow-input-labels">
            <span>Target</span>
            <span>Actual</span>
          </div>
          <div class="workflow-input" *ngFor="let varStaff of shiftRecord.costCenter.variableJobTitles">
            <input type="text" disabled [attr.aria-label]="'Target ' + varStaff.abbreviation" [value]="getRecommendedStaffText(varStaff.id)">
            <input type="number" min="0" [attr.aria-label]="'Actual ' + varStaff.abbreviation" [formControlName]="getStaffControlName(varStaff.id)">
            <span class="display-label">{{ varStaff.abbreviation }}</span>
            <div *ngIf="controlValueOutOfRange(varStaff.id)" class="validation-message warning">
              Value must be between {{minValue}} and {{maxValue | number}}.
          </div>
          </div>
        </section>

        <section *ngIf="shiftRecord.costCenter.fixedJobTitles.length" class="workflow-input-group">            
          <a class="workflow-section-link" (click)="toggleFixedStaff()">Fixed Staff</a>
          &nbsp;
          <button class="compact" (click)="toggleFixedJobEditing()"><span class="icon-pencil"></span> Edit</button>
          <ng-template [ngIf]="showFixedStaff">                 
            <div class="workflow-input-labels">
              <span>Target</span>
              <span>Actual</span>
            </div>
            <div class="workflow-input" *ngFor="let fixed of shiftRecord.costCenter.fixedJobTitles">
              <input type="text" disabled [attr.aria-label]="'Target ' + fixed.abbreviation" [value]="getFixedStaffText(fixed.id)">
              <input type="number" min="0" [attr.aria-label]="'Actual ' + fixed.abbreviation" [formControlName]="getStaffControlName(fixed.id)">
              <span class="display-label">{{ fixed.abbreviation }}</span>
              <div *ngIf="controlValueOutOfRange(fixed.id)" class="validation-message warning">
                Value must be between {{minValue}} and {{maxValue | number}}.
              </div>
            </div>
          </ng-template>  
        </section>
        
        <div *ngIf="hasImportedData()">
            <input id="reviewed" type="checkbox" value="checkbox" formControlName="reviewed">
            <label for="reviewed">Reviewed</label>
        </div>
      </section>
    </div>
</div>
